import { ArrowRight, BadgeCheck, Box, KeyRound, ScanLine, ShieldCheck } from "lucide-react";
import { FormEvent, useEffect, useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { Logo } from "../components/Logo";
import { ApiError } from "../lib/api";
import { getDeviceId } from "../lib/device";

export function ActivatePage() {
  const { loading, token, account, activate, logout } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [code, setCode] = useState(params.get("code") ?? "");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const incoming = params.get("code");
    if (incoming) setCode(incoming);
  }, [params]);

  if (!loading && !token) return <Navigate to={`/login?next=${encodeURIComponent(`/activate?code=${code}`)}`} replace />;
  if (account?.license?.status === "active") return <Navigate to="/app" replace />;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await activate(code, getDeviceId());
      navigate("/app", { replace: true });
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : "No pudimos activar el código");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="activation-page">
      <header className="activation-header"><Logo compact /><button className="text-link" onClick={logout}>Salir</button></header>
      <main className="activation-main">
        <div className="activation-illustration"><div className="box-icon"><Box size={54} /></div><div className="qr-mini"><ScanLine size={30} /></div></div>
        <span className="step-label">Paso 2 de 2</span>
        <h1>Activá tus LingoSound XR4</h1>
        <p>Escaneá el QR que viene dentro de la caja o escribí el código único de activación.</p>
        <form onSubmit={submit} className="activation-form">
          <label>Código de activación<div className="code-input"><KeyRound size={20} /><input value={code} onChange={(event) => setCode(event.target.value.toUpperCase())} placeholder="LSXR4-XXXX-XXXX-XXXX" autoCapitalize="characters" required /></div></label>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="button primary large" disabled={busy}>{busy ? "Verificando…" : <>Activar mi XR4 <ArrowRight size={19} /></>}</button>
        </form>
        <div className="activation-benefits">
          <div><ShieldCheck size={19} /><span><strong>Activación segura</strong><small>Un código, una cuenta, un dispositivo</small></span></div>
          <div><BadgeCheck size={19} /><span><strong>Acceso oficial</strong><small>Traducción y soporte LingoSound</small></span></div>
        </div>
        <p className="support-note">¿No encontrás tu código? <a href="mailto:ventas@lingosound.com?subject=Ayuda%20con%20mi%20código%20XR4">Contactá a soporte</a></p>
      </main>
    </div>
  );
}
